import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const API = 'https://b2b-rocca-production.up.railway.app/api';

export default function AdminPage() {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [tab, setTab] = useState('categories');
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newCatName, setNewCatName] = useState('');
  const [editCat, setEditCat] = useState(null);
  const [selectedCat, setSelectedCat] = useState('');
  const [search, setSearch] = useState('');
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [msg, setMsg] = useState('');

  const h = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };

  const showMsg = (t) => { setMsg(t); setTimeout(() => setMsg(''), 3000); };

  const load = useCallback(async () => {
    try {
      const [c, p, o] = await Promise.all([
        fetch(`${API}/categories`, { headers: h }).then(r => r.json()),
        fetch(`${API}/products?all=true`, { headers: h }).then(r => r.json()),
        fetch(`${API}/orders`, { headers: h }).then(r => r.json()),
      ]);
      setCategories(Array.isArray(c) ? c : []);
      setProducts(Array.isArray(p) ? p : []);
      setOrders(Array.isArray(o) ? o : []);
    } catch(e) { console.error(e); }
    setLoading(false);
  }, [token]);

  useEffect(() => {
    if (!token) { navigate('/login'); return; }
    load();
  }, [token, navigate, load]);

  const addCat = async () => {
    if (!newCatName.trim()) return;
    await fetch(`${API}/categories`, { method:'POST', headers:h, body:JSON.stringify({name:newCatName}) });
    setNewCatName(''); load(); showMsg('✅ Категорію додано');
  };

  const saveCat = async () => {
    await fetch(`${API}/categories/${editCat.id}`, { method:'PUT', headers:h, body:JSON.stringify(editCat) });
    setEditCat(null); load(); showMsg('✅ Збережено');
  };

  const delCat = async (id) => {
    if (!window.confirm('Видалити?')) return;
    await fetch(`${API}/categories/${id}`, { method:'DELETE', headers:h });
    load(); showMsg('✅ Видалено');
  };

  const assign = async () => {
    if (!selectedCat || !selectedProducts.length) return;
    await fetch(`${API}/categories/assign/products`, {
      method:'PUT', headers:h,
      body:JSON.stringify({ category_id: parseInt(selectedCat), product_ids: selectedProducts })
    });
    setSelectedProducts([]); load(); showMsg(`✅ ${selectedProducts.length} товарів прив'язано`);
  };

  const updateStatus = async (id, status) => {
    await fetch(`${API}/orders/${id}`, { method:'PUT', headers:h, body:JSON.stringify({status}) });
    load(); showMsg('✅ Статус оновлено');
  };

  const [stockInputs, setStockInputs] = useState({});
  const getStockInput = (id) => stockInputs[id] ?? '';
  const setStockInput = (id, val) => setStockInputs(prev => ({...prev, [id]: val}));

  const addStock = async (id) => {
    const val = parseInt(getStockInput(id), 10);
    if (!val || val <= 0) return;
    await fetch(`${API}/products/${id}/stock`, { method:'PUT', headers:h, body:JSON.stringify({ quantity: val, mode: 'add' }) });
    setStockInput(id, '');
    load(); showMsg(`✅ Додано ${val} шт до залишку`);
  };

  const setStockAbsolute = async (id) => {
    const val = parseInt(getStockInput(id), 10);
    if (isNaN(val) || val < 0) return;
    await fetch(`${API}/products/${id}/stock`, { method:'PUT', headers:h, body:JSON.stringify({ quantity: val, mode: 'set' }) });
    setStockInput(id, '');
    load(); showMsg(`✅ Залишок встановлено: ${val} шт`);
  };

  const [uploadingId, setUploadingId] = useState(null);

  const handlePhotoUpload = async (id, file) => {
    if (!file) return;
    setUploadingId(id);
    const formData = new FormData();
    formData.append('photo', file);
    try {
      const res = await fetch(`${API}/upload/${id}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      if (!res.ok) throw new Error('Помилка завантаження');
      await load();
      showMsg('✅ Фото завантажено');
    } catch (e) {
      showMsg('❌ Не вдалося завантажити фото');
    } finally {
      setUploadingId(null);
    }
  };

  const filtered = products.filter(p =>
    p.name.toLowerCase().includes(search.toLowerCase()) ||
    (p.brand||'').toLowerCase().includes(search.toLowerCase()) ||
    (p.barcode||'').includes(search) ||
    (p.supplier_code||'').includes(search) ||
    (p.vendor_code||'').includes(search)
  );

  const statuses = { new:'Новий', processing:'Обробляється', shipped:'В дорозі', delivered:'Доставлено', cancelled:'Скасовано' };

  if (loading) return <div style={{padding:'100px 40px', textAlign:'center'}}>Завантаження...</div>;

  return (
    <div style={{minHeight:'100vh', background:'#F8F6F0', padding:'80px 40px 40px'}}>
      {msg && <div style={{position:'fixed',bottom:24,right:24,background:'#0D1B2A',color:'#fff',padding:'12px 24px',borderRadius:8,zIndex:999}}>{msg}</div>}
      <div style={{maxWidth:1100, margin:'0 auto'}}>
        <div style={{display:'flex', justifyContent:'space-between', marginBottom:32}}>
          <h1 style={{fontFamily:'Georgia,serif', fontSize:32, color:'#0D1B2A'}}>Адмін-панель</h1>
          <button onClick={() => navigate('/cabinet')} style={{background:'#0D1B2A',color:'#fff',border:'none',padding:'10px 20px',borderRadius:8,cursor:'pointer'}}>← Кабінет</button>
        </div>

        {/* Таби */}
        <div style={{display:'flex', gap:4, borderBottom:'2px solid #E2DECE', marginBottom:32}}>
          {[['categories',`Категорії (${categories.length})`],['assign',"Прив'язати товари"],['orders',`Замовлення (${orders.length})`],['products',`Товари (${products.length})`]].map(([k,v]) => (
            <button key={k} onClick={() => setTab(k)} style={{padding:'10px 20px',background:'none',border:'none',cursor:'pointer',fontSize:14,fontWeight:tab===k?700:400,color:tab===k?'#0D1B2A':'#6B7280',borderBottom:tab===k?'2px solid #C9A84C':'2px solid transparent',marginBottom:-2}}>{v}</button>
          ))}
        </div>

        {/* КАТЕГОРІЇ */}
        {tab==='categories' && (
          <>
            <div style={{background:'#fff',borderRadius:12,border:'1px solid #E2DECE',padding:24,marginBottom:20}}>
              <div style={{fontWeight:700,marginBottom:16}}>Додати категорію</div>
              <div style={{display:'flex',gap:12}}>
                <input style={{flex:1,padding:'10px 14px',border:'1px solid #E2DECE',borderRadius:8,fontSize:14,outline:'none'}} placeholder="Назва категорії" value={newCatName} onChange={e=>setNewCatName(e.target.value)} onKeyDown={e=>e.key==='Enter'&&addCat()} />
                <button onClick={addCat} style={{background:'#0D1B2A',color:'#fff',border:'none',padding:'10px 20px',borderRadius:8,cursor:'pointer',fontWeight:600}}>Додати</button>
              </div>
            </div>
            <div style={{background:'#fff',borderRadius:12,border:'1px solid #E2DECE',padding:24}}>
              <div style={{fontWeight:700,marginBottom:16}}>Всі категорії</div>
              {categories.map(cat => (
                <div key={cat.id} style={{display:'flex',alignItems:'center',gap:12,padding:'10px 0',borderBottom:'1px solid #F1F1EF'}}>
                  {editCat?.id===cat.id ? (
                    <>
                      <input style={{flex:1,padding:'8px 12px',border:'1px solid #E2DECE',borderRadius:6,outline:'none'}} value={editCat.name} onChange={e=>setEditCat({...editCat,name:e.target.value})} />
                      <input style={{width:160,padding:'8px 12px',border:'1px solid #E2DECE',borderRadius:6,outline:'none'}} value={editCat.slug||''} onChange={e=>setEditCat({...editCat,slug:e.target.value})} />
                      <button onClick={saveCat} style={{background:'#065F46',color:'#fff',border:'none',padding:'8px 16px',borderRadius:6,cursor:'pointer'}}>Зберегти</button>
                      <button onClick={()=>setEditCat(null)} style={{background:'#6B7280',color:'#fff',border:'none',padding:'8px 16px',borderRadius:6,cursor:'pointer'}}>Скасувати</button>
                    </>
                  ) : (
                    <>
                      <span style={{flex:1,fontWeight:500}}>{cat.name}</span>
                      <span style={{fontSize:12,color:'#9CA3AF',width:160}}>{cat.slug}</span>
                      <span style={{fontSize:12,color:'#6B7280',width:100}}>{products.filter(p=>p.category_id===cat.id).length} товарів</span>
                      <button onClick={()=>setEditCat({...cat})} style={{background:'#1B3A5C',color:'#fff',border:'none',padding:'8px 16px',borderRadius:6,cursor:'pointer'}}>Редагувати</button>
                      <button onClick={()=>delCat(cat.id)} style={{background:'#DC2626',color:'#fff',border:'none',padding:'8px 16px',borderRadius:6,cursor:'pointer'}}>Видалити</button>
                    </>
                  )}
                </div>
              ))}
            </div>
          </>
        )}

        {/* ПРИВ'ЯЗАТИ */}
        {tab==='assign' && (
          <div style={{background:'#fff',borderRadius:12,border:'1px solid #E2DECE',padding:24}}>
            <div style={{fontWeight:700,marginBottom:16}}>Прив'язати товари до категорії</div>
            <div style={{display:'flex',gap:12,marginBottom:16,flexWrap:'wrap'}}>
              <select value={selectedCat} onChange={e=>setSelectedCat(e.target.value)} style={{padding:'10px 14px',border:'1px solid #E2DECE',borderRadius:8,outline:'none'}}>
                <option value="">Оберіть категорію...</option>
                {categories.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
              <input style={{flex:1,minWidth:200,padding:'10px 14px',border:'1px solid #E2DECE',borderRadius:8,outline:'none'}} placeholder="Пошук товарів..." value={search} onChange={e=>setSearch(e.target.value)} />
              <button onClick={assign} disabled={!selectedCat||!selectedProducts.length} style={{background:'#065F46',color:'#fff',border:'none',padding:'10px 20px',borderRadius:8,cursor:'pointer',fontWeight:600}}>Прив'язати ({selectedProducts.length})</button>
              {selectedProducts.length>0 && <button onClick={()=>setSelectedProducts([])} style={{background:'#6B7280',color:'#fff',border:'none',padding:'10px 16px',borderRadius:8,cursor:'pointer'}}>Скинути</button>}
            </div>
            <div style={{maxHeight:500,overflowY:'auto'}}>
              {filtered.map(p=>(
                <div key={p.id} onClick={()=>setSelectedProducts(prev=>prev.includes(p.id)?prev.filter(i=>i!==p.id):[...prev,p.id])}
                  style={{display:'flex',alignItems:'center',gap:12,padding:'10px',cursor:'pointer',background:selectedProducts.includes(p.id)?'#EFF6FF':'transparent',borderRadius:6,marginBottom:2}}>
                  <input type="checkbox" checked={selectedProducts.includes(p.id)} readOnly />
                  <span style={{flex:1,fontSize:13}}>{p.name}</span>
                  <span style={{fontSize:12,color:'#C9A84C',width:120}}>{p.brand}</span>
                  <span style={{fontSize:12,color:'#6B7280',width:180}}>{categories.find(c=>c.id===p.category_id)?.name||'—'}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ЗАМОВЛЕННЯ */}
        {tab==='orders' && (
          <div style={{background:'#fff',borderRadius:12,border:'1px solid #E2DECE',padding:24}}>
            <div style={{fontWeight:700,marginBottom:16}}>Всі замовлення</div>
            {orders.length===0 ? <div style={{textAlign:'center',padding:40,color:'#6B7280'}}>Замовлень немає</div> : (
              <table style={{width:'100%',borderCollapse:'collapse'}}>
                <thead>
                  <tr>{['№','Клієнт','Дата','Сума','Статус','Змінити'].map(h=><th key={h} style={{textAlign:'left',padding:'10px 12px',fontSize:12,fontWeight:700,color:'#6B7280',borderBottom:'2px solid #E2DECE',textTransform:'uppercase'}}>{h}</th>)}</tr>
                </thead>
                <tbody>
                  {orders.map(o=>(
                    <tr key={o.id}>
                      <td style={{padding:'12px',fontSize:13,borderBottom:'1px solid #F1F1EF'}}><strong>#{o.id}</strong></td>
                      <td style={{padding:'12px',fontSize:13,borderBottom:'1px solid #F1F1EF'}}>{o.client_name||'—'}<br/><span style={{fontSize:11,color:'#9CA3AF'}}>{o.company}</span></td>
                      <td style={{padding:'12px',fontSize:13,borderBottom:'1px solid #F1F1EF'}}>{new Date(o.created_at).toLocaleDateString('uk-UA')}</td>
                      <td style={{padding:'12px',fontSize:13,borderBottom:'1px solid #F1F1EF'}}><strong>{Number(o.total).toLocaleString()} ₴</strong></td>
                      <td style={{padding:'12px',fontSize:13,borderBottom:'1px solid #F1F1EF'}}>{statuses[o.status]}</td>
                      <td style={{padding:'12px',fontSize:13,borderBottom:'1px solid #F1F1EF'}}>
                        <select value={o.status} onChange={e=>updateStatus(o.id,e.target.value)} style={{padding:'6px 10px',border:'1px solid #E2DECE',borderRadius:6,outline:'none'}}>
                          {Object.entries(statuses).map(([k,v])=><option key={k} value={k}>{v}</option>)}
                        </select>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}

        {/* ТОВАРИ */}
        {tab==='products' && (
          <div style={{background:'#fff',borderRadius:12,border:'1px solid #E2DECE',padding:24}}>
            <div style={{fontWeight:700,marginBottom:16}}>Всі товари</div>
            <input style={{width:'100%',padding:'10px 14px',border:'1px solid #E2DECE',borderRadius:8,outline:'none',marginBottom:16,boxSizing:'border-box'}} placeholder="Пошук..." value={search} onChange={e=>setSearch(e.target.value)} />
            <table style={{width:'100%',borderCollapse:'collapse'}}>
              <thead>
                <tr>{['Фото','Назва','Бренд','Категорія','Ціна','Залишок','Керування'].map(h=><th key={h} style={{textAlign:'left',padding:'10px 12px',fontSize:12,fontWeight:700,color:'#6B7280',borderBottom:'2px solid #E2DECE',textTransform:'uppercase'}}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {filtered.slice(0,100).map(p=>(
                  <tr key={p.id}>
                    <td style={{padding:'10px 12px',borderBottom:'1px solid #F1F1EF'}}>
                      {p.image_url ? (
                        <img src={p.image_url} alt="" style={{width:40,height:40,objectFit:'cover',borderRadius:6}} />
                      ) : (
                        <div style={{width:40,height:40,background:'#F1F1EF',borderRadius:6,display:'flex',alignItems:'center',justifyContent:'center',fontSize:16}}>📦</div>
                      )}
                      <input
                        type="file"
                        accept="image/*"
                        id={`photo-${p.id}`}
                        style={{display:'none'}}
                        onChange={e => handlePhotoUpload(p.id, e.target.files[0])}
                      />
                      <label htmlFor={`photo-${p.id}`} style={{display:'block',fontSize:10,color:'#1B3A5C',cursor:'pointer',marginTop:4,textAlign:'center'}}>
                        {uploadingId === p.id ? 'Завантаження...' : 'Змінити'}
                      </label>
                    </td>
                    <td style={{padding:'10px 12px',fontSize:12,borderBottom:'1px solid #F1F1EF'}}>{p.name}</td>
                    <td style={{padding:'10px 12px',fontSize:12,borderBottom:'1px solid #F1F1EF'}}>{p.brand||'—'}</td>
                    <td style={{padding:'10px 12px',fontSize:12,borderBottom:'1px solid #F1F1EF'}}>{categories.find(c=>c.id===p.category_id)?.name||'—'}</td>
                    <td style={{padding:'10px 12px',fontSize:12,borderBottom:'1px solid #F1F1EF'}}>{Number(p.price).toLocaleString()} ₴</td>
                    <td style={{padding:'10px 12px',fontSize:12,borderBottom:'1px solid #F1F1EF'}}>
                      {p.quantity_in_stock === null ? <span style={{color:'#9CA3AF'}}>Без обліку</span> : (
                        <span style={{fontWeight:700, color: p.quantity_in_stock > 0 ? '#065F46' : '#DC2626'}}>{p.quantity_in_stock} шт</span>
                      )}
                    </td>
                    <td style={{padding:'10px 12px',fontSize:12,borderBottom:'1px solid #F1F1EF'}}>
                      <div style={{display:'flex', gap:6, alignItems:'center'}}>
                        <input
                          type="number"
                          placeholder="0"
                          value={getStockInput(p.id)}
                          onChange={e => setStockInput(p.id, e.target.value)}
                          style={{width:60, padding:'6px 8px', border:'1px solid #E2DECE', borderRadius:6, fontSize:12, outline:'none'}}
                        />
                        <button onClick={() => addStock(p.id)} title="Додати до існуючого" style={{background:'#065F46',color:'#fff',border:'none',padding:'6px 10px',borderRadius:6,cursor:'pointer',fontSize:11,fontWeight:600}}>+ Додати</button>
                        <button onClick={() => setStockAbsolute(p.id)} title="Встановити точну кількість" style={{background:'#1B3A5C',color:'#fff',border:'none',padding:'6px 10px',borderRadius:6,cursor:'pointer',fontSize:11,fontWeight:600}}>Задати</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {filtered.length>100 && <div style={{textAlign:'center',padding:16,color:'#6B7280',fontSize:13}}>Показано 100 з {filtered.length}. Уточніть пошук.</div>}
          </div>
        )}
      </div>
    </div>
  );
}
